export default function NotFound() {
  return (
    <main className="min-h-screen bg-background-50 pt-24 pb-16">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 text-center py-20">
        <div className="w-20 h-20 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-6">
          <i className="ri-emotion-sad-line text-foreground-400 text-3xl"></i>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">404 页面未找到</h1>
        <p className="text-sm text-foreground-500 mb-8">抱歉，您访问的页面不存在或已被移除</p>
        <a
          href="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line text-sm"></i>
          返回首页
        </a>
      </div>
    </main>
  );
}